export default "__VITE_ASSET__DaX3G2gb__"